import React, { useEffect, useRef } from "react";

export default function PopupModal({ isOpen, title, message, onClose }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const el = dialogRef.current;
    if (!el) return;
    if (isOpen) {
      if (!el.open) el.showModal();
    } else {
      if (el.open) el.close();
    }
  }, [isOpen]);

  useEffect(() => {
    const el = dialogRef.current;
    if (!el) return;
    const handleCancel = (e) => {
      e.preventDefault();
      onClose();
    };
    el.addEventListener("cancel", handleCancel);
    return () => el.removeEventListener("cancel", handleCancel);
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <dialog
      ref={dialogRef}
      className="fixed inset-0 z-[200] m-auto p-0 border-0 bg-transparent backdrop:bg-black/60 backdrop:backdrop-blur-sm rounded-2xl max-w-sm w-full outline-none"
    >
      <div className="bg-white/95 backdrop-blur-xl border border-white/80 rounded-2xl shadow-2xl w-full p-6 text-center animate-in fade-in zoom-in-95 duration-200">
        <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-orange-50 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-6 h-6 text-orange-500"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h2 className="text-lg font-bold text-slate-900 mb-2">
          {title}
        </h2>
        <p className="text-sm text-slate-600 leading-relaxed mb-6 whitespace-pre-line">
          {message}
        </p>
        <button
          type="button"
          onClick={onClose}
          className="w-full py-2.5 px-6 rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold text-sm transition-colors shadow-md shadow-orange-500/20"
        >
          OK
        </button>
      </div>
    </dialog>
  );
}